import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache:true
};
const noCacheMeta = {
    auth: false
};

export default {
    path: '/org',
    name: 'org',
    redirect: {
        name: 'userManager'
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: '/org/userList',
            name: 'userManager',
            meta: {
                ...meta,
                title: '$t:menu.userList',
                desc: '用户管理'
            },
            component: () => import('@/pages/org/user/userList.vue')
        },
        {
            path: '/org/userEdit/:id',
            name: 'userManager_edit',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.userManager_edit',
                desc: '编辑用户'
            },
            component: () => import('@/pages/org/user/userEdit.vue')
        }, {
            path: '/org/userEdit',
            name: 'userManager_add',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.userManager_edit',
                desc: '新增用户'
            },
            component: () => import('@/pages/org/user/userEdit.vue')
        },
        {
            path: '/org/orgManager',
            name: 'orgManager',
            meta: {
                ...meta,
                title: '$t:menu.org',
                desc: '组织管理'
            },
            component: () => import('@/pages/org/group/groupList.vue')
        },
        {
            path: '/org/roleEdit/:id',
            name: 'roleManager_edit',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.roleEdit',
                desc: '编辑角色'
            },
            component: () => import('@/pages/org/role/roleEdit.vue')
        },{
            path: '/org/roleEdit',
            name: 'roleManager_add',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.roleEdit',
                desc: '新增角色'
            },
            component: () => import('@/pages/org/role/roleEdit.vue')
        },
        {
            path: '/org/roleEdit/:id',
            name: 'roleManager_users',
            meta: {
                ...meta,
                title: '$t:menu.roleManager_users',
                desc: '角色用户管理'
            },
            component: () => import('@/pages/org/role/roleUserList.vue')
        },
        {
            path: '/org/roleList',
            name: 'roleManager',
            meta: {
                ...meta,
                title: '$t:menu.roleMananger',
                desc: '角色管理'
            },
            component: () => import('@/pages/org/role/roleList.vue')
        },
        {
            path:'/bpm/instance/taskList',
            name:'taskList',
            meta: {
                ...meta,
                title:'任务列表'
            },
            component: () => import('@/pages/bpm/instance/taskList')
        },
        {
            path: '/bpm/instance/taskOpinionHistory/:id',
            name: 'taskOpinionHistory',
            meta: {
                auth: false,
                cache: false,
                title:'任务情况',
            },
            component: () => import('@/pages/bpm/instance/taskOpinionHistory.vue')
        },
        {
            path:'/bpm/instance/instanceList',
            name:'instanceList',
            meta: {
                ...meta,
                title:'流程实例'
            },
            component:()=> import('@/pages/bpm/instance/instanceList')
        },
        {
            path:'/bpm/instance/instanceList_org',
            name:'instanceList_org',
            meta: {
                ...meta,
                title:'流程实例-部门'
            },
            component:()=> import('@/pages/bpm/instance/instanceList_org')
        },
    ]
};
